import { useTranslation } from 'react-i18next';
import './Home.css';

export default function Home() {
  const { t } = useTranslation();

  return (
    <div className="home">
      <img src="/logo.png" alt="Nulune Logo" className="home-logo" />
      <h1 className="home-title">Nulune</h1>
      <p className="home-tagline">{t('home.tagline')}</p>
    </div>
  );
}
